import { Col } from "antd";
import HeroSpin from "/app/src/components/HeroUi/Spin";
import { NumberDatum } from "./types";

/**
 * Display a number value. The class styling is based on the number of datasets
 */
export default function Number({
  dataset,
  snapshotsAmount,
  isLoading,
}: {
  dataset?: NumberDatum;
  snapshotsAmount?: number;
  isLoading?: boolean;
}) {
  if (isLoading) {
    return <HeroSpin />;
  } else {
    return (
      <Col span={snapshotsAmount > 2 ? 12 : 24}>
        <div
          className={
            snapshotsAmount === 1
              ? "single number"
              : snapshotsAmount === 2
                ? "double number"
                : "quad number"
          }
        >
          <h1 style={{ color: dataset.color }}>
            {typeof dataset.value === "number" && dataset.value % 1 !== 0
              ? dataset.value.toFixed(2)
              : dataset.value}
          </h1>
          <span>{dataset.label}</span>
        </div>
      </Col>
    );
  }
}
